export default {
  // アカウントID
  ACCOUNT_ID: 'account_id',

  // 社員番号
  EMPLOYEE_ID: 'employee_id',

  // 氏名
  NAME: 'name',

  // 電話番号
  TELEPHONE: 'telephone',

  // 住所
  ADDRESS: 'address',

  // E-Mail
  EMAIL: 'email',

  // パスワード
  PASSWORD: 'password',

  // ユーザ種別
  AUTHORITY_ID: 'authority_id',

  // 承認者選択
  APPROVER_FLG: 'approver_flg',

  // 所属部署ID
  DEPARTMENT_ID: 'department_id',
  
  // 有給日数
  PAID_DAYS: 'paid_days',

  // 代休日数
  COMP_DAYS: 'comp_days',

  //Slack ID
  SLACK_ID: 'slack_id',

  // 削除フラグ
  DELETED_FLG: 'deleted_flg',

  // 削除フラグ 削除されていない場合の値
  REMAIN: 0,

  // 削除フラグ 削除済み場合の値
  DELETE: 1,

  // エラーコード500
  ERROR_500: 500,

  // エラーページ500の名称
  PAGE_500: 'Page500',

  // ユーザ管理画面への相対パス
  ROUTE_LIST: 'ユーザ管理',

  // vue-routerでユーザ詳細に遷移する際のname
  ROUTE_INFO: 'ユーザ詳細',

  // ユーザ登録画面上部への相対パス
  REGISTER_TOP: 'users/register',

  // vue-routerでユーザ更新に遷移する際のname
  UPDATE_TOP: 'ユーザ更新'
}
